
// Updated_ImageUploadPreviewModal.js

import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import Slider from "@mui/material/Slider";
//import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress'; 


const ImageUploadPreviewModal = ({
  open,
  onClose,
  imageFile,
  selectedShape,
  shapeParams,
  threadSize,
  pinCount,
  boardSize,
  maxLines
 // onGenerate,
}) => {
 

  const canvasRef = useRef();
  const abortRef = useRef(null);
  const [image, setImage] = useState(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [scale, setScale] = useState(1);
  const [contrast, setContrast] = useState(0); // -100 to 100
  const [brightness, setBrightness] = useState(0);

  const [isGenerating, setIsGenerating] = useState(false);
const [statusText, setStatusText] = useState("Preparing…");
const [progress, setProgress] = useState(null); // null => indeterminate
//const [elapsed, setElapsed] = useState(0);
const timerRef = useRef(null);

const startGeneratingUI = () => {
  setIsGenerating(true);
  setStatusText("Preparing…");
  setProgress(null);  // determinate கிடையாது என்றால் null-ஆ விடுங்க
  // setElapsed(0);
  // timerRef.current = setInterval(() => setElapsed(e => e + 1), 1000);
};

const stopGeneratingUI = () => {
  setIsGenerating(false);
  clearInterval(timerRef.current);
  timerRef.current = null;
};

useEffect(() => {
  if (!isGenerating) return;
  const steps = [
    "Preparing image…",
    "Detecting edges…",
    "Scoring lines…",
    "Optimizing path…",
    "Rendering preview…",
  ];
  let k = 0;
  setStatusText(steps[0]);
  const id = setInterval(() => {
    k = (k + 1) % steps.length;
    setStatusText(steps[k]);
  }, 3200);
  return () => clearInterval(id);
}, [isGenerating]);



  const dragStart = useRef({ x: 0, y: 0 });
  const pinchStart = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (!imageFile) return;
    const img = new Image();
    img.onload = () => setImage(img);
    img.src = URL.createObjectURL(imageFile);
  }, [imageFile]);

  useEffect(() => {
    if (!image || !open) return;
    
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d"); 
    const canvasSize = 500;
    const width = canvasSize;
    const height = canvasSize;
    const centerX = width / 2;
    const centerY = height / 2;
    const radius = shapeParams.radius || shapeParams.size || 200;

    canvas.width = width;
    canvas.height = height;

    ctx.clearRect(0, 0, width, height);

    const imgWidth = image.width;
    const imgHeight = image.height;
    const baseScale = Math.min(width / imgWidth, height / imgHeight);
    const scaledWidth = imgWidth * baseScale * scale;
    const scaledHeight = imgHeight * baseScale * scale;
    const dx = offset.x + (width - scaledWidth) / 2;
    const dy = offset.y + (height - scaledHeight) / 2;

    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = scaledWidth;
    tempCanvas.height = scaledHeight;
    const tempCtx = tempCanvas.getContext("2d");
    tempCtx.drawImage(image, 0, 0, scaledWidth, scaledHeight);

    const imgData = tempCtx.getImageData(0, 0, scaledWidth, scaledHeight);
    const data = imgData.data;
    // for (let i = 0; i < data.length; i += 4) {
    //   const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
    //   data[i] = data[i + 1] = data[i + 2] = avg;
    // }
    const f = (259 * (contrast + 255)) / (255 * (259 - contrast));
for (let i = 0; i < data.length; i += 4) {
  const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
  let v = f * (avg - 128) + 128; 
  v = v + brightness;
  v = Math.max(0, Math.min(255, v));
  data[i] = data[i + 1] = data[i + 2] = v;
}
    tempCtx.putImageData(imgData, 0, 0);

    ctx.save();
    ctx.beginPath();
    if (selectedShape === "circle") {
      ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
    } else if (selectedShape === "square") {
      const size = shapeParams.size || 200;
      ctx.rect((width - size) / 2, (height - size) / 2, size, size);
    } else if (selectedShape === "rectangle") {
      const w = shapeParams.width || 200;
      const h = shapeParams.height || 150;
      ctx.rect((width - w) / 2, (height - h) / 2, w, h);
    } else if (selectedShape === "heart") {
      const size = shapeParams.size || 300;
      const x = centerX;
      const y = centerY - 30;
      const bottomY = y + size * 0.5;
      ctx.moveTo(x, bottomY);
      ctx.bezierCurveTo(x + size * 0.6, y + size * 0.2, x + size * 0.6, y - size * 0.5, x, y - size * 0.23);
      ctx.bezierCurveTo(x - size * 0.6, y - size * 0.5, x - size * 0.6, y + size * 0.2, x, bottomY);
    } else {
      ctx.rect(0, 0, width, height);
    }
    ctx.clip();

    ctx.drawImage(tempCanvas, dx, dy, scaledWidth, scaledHeight);
    ctx.restore();

  }, [image, open, offset, scale, selectedShape, shapeParams, contrast,brightness]);



const handleGenerateClick = () => {
  // const canvas = canvasRef.current;
  // if (!canvas) return;

  // canvas.toBlob(async (blob) => {
  //   if (!blob) return;

   if (isGenerating) return;           // double-click guard
  startGeneratingUI();                // ✅ START UI

  const canvas = canvasRef.current;
  if (!canvas) { stopGeneratingUI(); return; }

  canvas.toBlob(async (blob) => {
    if (!blob) { stopGeneratingUI(); return; }

    const formData = new FormData();
    formData.append("image", blob, "string_art.png");
   // formData.append("pinCount", 300); // You can make this dynamic later
    formData.append("shape", selectedShape);
    formData.append("shapeParams", JSON.stringify(shapeParams));
    formData.append("resolution", "high");
    formData.append("contrast", contrast);
    formData.append("brightness", brightness);
    formData.append("boardSize", boardSize);
formData.append("threadSize", threadSize);
formData.append("maxLines", maxLines);
formData.append("pinCount",pinCount)



    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/generate-string-art`, {
      //  const res = await fetch(`http://localhost:5000/api/generate-string-art`, {
  method: "POST",
  body: formData,
});

 

     
      const result = await res.json();
const imageUrl = `data:image/png;base64,${result.image}`;

 onClose();
navigate("/preview", {
  state: {
    imageUrl,
    pins: result.pins,
    lines: result.lines,
    debug: result.debug,
    svg: result.svg, 
    width: 1000,
    height: 1000,
  },
});

  }, "image/png");
};

  return (
    <Dialog open={open}  maxWidth="xl" fullWidth>
      <DialogTitle>Adjust Image Inside {selectedShape}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" mb={2}>
          Zoom and drag the image to align it inside the shape preview:
        </Typography>
        <canvas
          ref={canvasRef}
          onWheel={(e) => {
            e.preventDefault();
            const delta = e.deltaY < 0 ? 0.1 : -0.1;
            setScale((prev) => Math.max(0.5, Math.min(3, prev + delta)));
          }}
          onMouseDown={(e) => {
            setIsDragging(true);
            dragStart.current = { x: e.clientX, y: e.clientY };
          }}
          onMouseMove={(e) => {
            if (!isDragging) return;
            const dx = e.clientX - dragStart.current.x;
            const dy = e.clientY - dragStart.current.y;
            dragStart.current = { x: e.clientX, y: e.clientY };
            setOffset((prev) => ({ x: prev.x + dx, y: prev.y + dy }));
          }}
          onMouseUp={() => setIsDragging(false)}
          onMouseLeave={() => setIsDragging(false)}
          onTouchStart={(e) => {
            if (e.touches.length === 2) {
              const dx = e.touches[0].clientX - e.touches[1].clientX;
              const dy = e.touches[0].clientY - e.touches[1].clientY;
              pinchStart.current = Math.sqrt(dx * dx + dy * dy);
            } else if (e.touches.length === 1) {
              dragStart.current = {
                x: e.touches[0].clientX,
                y: e.touches[0].clientY,
              };
              setIsDragging(true);
            }
          }}
          onTouchMove={(e) => {
            if (e.touches.length === 2 && pinchStart.current) {
              const dx = e.touches[0].clientX - e.touches[1].clientX;
              const dy = e.touches[0].clientY - e.touches[1].clientY;
              const pinchCurrent = Math.sqrt(dx * dx + dy * dy);
              const scaleDelta = pinchCurrent / pinchStart.current;
              setScale((prev) => Math.max(0.5, Math.min(3, prev * scaleDelta)));
              pinchStart.current = pinchCurrent;
            } else if (e.touches.length === 1 && isDragging) {
              const dx = e.touches[0].clientX - dragStart.current.x;
              const dy = e.touches[0].clientY - dragStart.current.y;
              dragStart.current = {
                x: e.touches[0].clientX,
                y: e.touches[0].clientY,
              };
              setOffset((prev) => ({ x: prev.x + dx, y: prev.y + dy }));
            }
          }}
          onTouchEnd={() => {
            setIsDragging(false);
            pinchStart.current = null;
          }}
          style={{
            border: "1px solid #ccc",
            width: "100%",
            maxWidth: "300px",
            height: "auto",
            cursor: isDragging ? "grabbing" : "grab",
            display: "block",
            margin: "0 auto",
            touchAction: "none",
            marginBottom: "1rem",
          }}
        />
    

 <Box sx={{ width: "100%", mt: 7 }}  style={{ width: "100%", maxWidth: "300px", display: "block",
            margin: "0 auto", }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0 }}>
        <Typography variant="body2" fontWeight={500}>
          Contrast
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {contrast}
        </Typography>
      </Box>
      <Slider
        value={contrast}
        min={-100}
        max={100}
        onChange={(e, newValue) => setContrast(newValue)}
        sx={{
    color: "#444", // 👈 dark grey instead of pure black
    "& .MuiSlider-thumb": {
      borderRadius: "50%",
      backgroundColor: "#444", // 👈 thumb dark grey
      boxShadow: "0 0 0 4px rgba(0,0,0,0.1)",
    },
    "& .MuiSlider-track": {
      border: "none",
    },
    "& .MuiSlider-rail": {
      opacity: 0.3,
      backgroundColor: "#aaa", // 👈 light grey rail for balance
    },
        }}
      />
    </Box>

    {/* <Box sx={{ width: "100%", mt: 4 }} style={{ width: "100%", maxWidth: "300px", margin: "0 auto" }}>
  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0 }}>
    <Typography variant="body2" fontWeight={500}>
      Brightness
    </Typography>
    <Typography variant="body2" color="text.secondary">
      {brightness}
    </Typography>
  </Box>
  <Slider
    value={brightness}
    min={-100}
    max={100}
    onChange={(e, newValue) => setBrightness(newValue)}
    sx={{
      color: "#888",
      "& .MuiSlider-thumb": {
        borderRadius: "50%",
        backgroundColor: "#888",
        boxShadow: "0 0 0 4px rgba(0,0,0,0.1)",
      },
      "& .MuiSlider-rail": {
        opacity: 0.3,
        backgroundColor: "#aaa",
      },
    }}
  />
</Box> */}

{isGenerating && (
    <Box
      sx={{
        position: "absolute", inset: 0,
        bgcolor: "rgba(255,255,255,0.72)",
        display: "flex", alignItems: "center", justifyContent: "center",
        p: 2
      }}
    >
    
      <Box
        sx={{
          width: 360, maxWidth: "90%",
          bgcolor: "background.paper",
          borderRadius: 3, boxShadow: 3, p: 3,
          display: "flex", flexDirection: "column", gap: 1.5
        }}
      >
       <Typography
  sx={{
    fontSize: 12,          // small size
    color: "#777",         // soft grey
   // textAlign: "center",
    mt: 0,
  }}
>
  This may take a moment. Please wait…
</Typography>
        {/* Spinner + status */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2}}>
          <CircularProgress size={28} sx={{ color: "black" }}/>
          <Typography sx={{ fontWeight: 600 }}>
            {statusText}
          </Typography>
        </Box>

        {/* Determinate progress இருந்தா காட்டும்; இல்லையென்றால் skip */}
        {Number.isFinite(progress) && (
          <>
            <LinearProgress variant="determinate" value={progress} />
            <Box sx={{ fontSize: 12, opacity: 0.8, textAlign: "right" }}>
              {progress}% complete
            </Box>
          </>
        )}

       
      </Box>
    </Box>
  )}

      </DialogContent>
      <DialogActions>
       {!isGenerating && (
    <Button onClick={onClose} color="secondary" sx={{
       textTransform: "none",         // UPPERCASE avoid
    fontSize: { xs: 13, sm: 14 },
      mt: 2,
      bgcolor: "lightgray",
      color: "#000" ,
      borderRadius: 1,
      
      "&:hover": {  color: "black"},
    }}>
      Cancel
    </Button>
  )}
        <Button
    onClick={handleGenerateClick}
    sx={{
       textTransform: "none",         // UPPERCASE avoid
    fontSize: { xs: 13, sm: 14 },
      mt: 2,
      bgcolor: "#111",
      color: "#fff",
      borderRadius: 1,
      
      "&:hover": { bgcolor: "#000" },
       "&.Mui-disabled": {
      bgcolor: "#222",
      color: "#fff",
    },
    }}
    
    disabled={isGenerating}
    startIcon={isGenerating ? <CircularProgress size={18} sx={{ color: "#fff",marginLeft:1 }} /> : null}
  >
    {isGenerating ? "Generating..." : "Generate String Art"}
  </Button>
 
      </DialogActions>
      

    </Dialog>
  );
};

export default ImageUploadPreviewModal; 

